import PropTypes from 'prop-types';
import React, { useState, useContext } from 'react';

import sortFilterGenericEvent from 'features/sort/sortFilterGenericEvent';
import setUtagDataForFdsDisplayType from 'features/sort/setUtagDataForFdsDisplayType';
import ChecklistDraftContext from 'features/sort/checklistDraftContext';
import { triggerEvent } from 'utilities/dom';

import SortFilterAttrGroupHeader from '../SortFilterAttrGroupHeader';

// Shared between Set DT 1 and 2 (Desktop and Mobile)
const AttrGroupSingleValueLink = ({
	name,
	attribute,
	attributeGroupFilterDisplayTypeId,
	headerImageSrc,
	headerImageAltTag,
	className
}) => {

	const [ utagCalled, setUtagCalled ] = useState(false);

	const { Url: firstValUrl, Name: firstValName } = attribute.AttributeValueGroups[0].AttributeValues[0];
	const { setIsNavigating } = useContext(ChecklistDraftContext);
	const handleValueClick = (event) => {

		if (!utagCalled) {

			setUtagDataForFdsDisplayType(name);
			sortFilterGenericEvent('filter_click', name, firstValName, true);
			setUtagCalled(true);

		}

		if (window.dynamicSort === true) {

			event.preventDefault();
			setIsNavigating(true);
			const destinationUrl = event.currentTarget.getAttribute('href');
			triggerEvent.call(document, 'dynamicNavigation', { destinationUrl });

		}

	};

	return (
		<a href={firstValUrl} onClick={handleValueClick} className={className}>
			<SortFilterAttrGroupHeader
				name={name}
				attributeGroupFilterDisplayTypeId={attributeGroupFilterDisplayTypeId}
				headerImageSrc={headerImageSrc}
				headerImageAltTag={headerImageAltTag}
			/>
		</a>
	);

};

AttrGroupSingleValueLink.propTypes = {
	name: PropTypes.string.isRequired,
	attribute: PropTypes.shape({
		AttributeValueGroups: PropTypes.arrayOf(
			PropTypes.shape({
				AttributeValues: PropTypes.arrayOf(
					PropTypes.shape({
						Url: PropTypes.string,
						Name: PropTypes.string
					})
				)
			})
		)
	}),
	attributeGroupFilterDisplayTypeId: PropTypes.number,
	headerImageSrc: PropTypes.string,
	headerImageAltTag: PropTypes.string,
	className: PropTypes.string
};

export default AttrGroupSingleValueLink;
